var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/trending-up-hd.81c5e686.png","uri@2x": __webpack_public_path__ + "static/media/trending-up-hd.80ca8a2c.png","uri@3x": __webpack_public_path__ + "static/media/trending-up-hd.880564f3.png",
    width: 64,
    height: 39
});